import React, { Component, useEffect, useState } from "react";
import { ScrollView, Text, View, TouchableOpacity } from "react-native";
import { SafeAreaView } from "react-navigation";
import { DrawerItems } from "react-navigation-drawer";
import { onSignOut } from "../../services/auth-service";
import {
  StackActions,
  NavigationActions,
  withNavigation,
} from "react-navigation";

import styles from "./styles";
import { Image } from "react-native";

import imgSenai from "../../../assets/logo_space.png";
import { getAluno } from "../../services/aluno-service";

function DrawerContent(props) {
  const [telefone, setTelefone] = useState(true);

  useEffect(() => {
    const temTelefoneValidado = async () => {
      const { telefones } = await getAluno(true);

      let encontrouVerificado = false;

      telefones.forEach((t) => {
        if (t.verificado === 1) encontrouVerificado = true;
      });

      if (!encontrouVerificado) setTelefone(false);
    };

    temTelefoneValidado();
  }, []);

  const sair = () => {
    onSignOut();
    const navigateAction = StackActions.reset({
      index: 0,
      actions: [NavigationActions.navigate({ routeName: "SignedOut" })],
    });
    props.navigation.dispatch(navigateAction);
  };

  return (
    <View style={{ flex: 1 }}>
      <ScrollView>
        <SafeAreaView forceInset={{ top: "always", horizontal: "never" }}>
          <View style={{ alignItems: "center" }}>
            <Image
              source={imgSenai}
              style={{
                width: "70%",
                height: 120,
                resizeMode: "center",
                marginVertical: 10,
              }}
            />
          </View>
          {telefone ? (
            <DrawerItems {...props} />
          ) : (
            <Text
              style={{
                fontFamily: "Montserrat",
                textAlign: "center",
                fontSize: 18,
                marginTop: 20,
                color: "#CCC",
              }}
            >
              Valide seu celular para começarmos
            </Text>
          )}
        </SafeAreaView>
      </ScrollView>
      <View elevation={6} style={{}}>
        <TouchableOpacity style={styles.botao} onPress={sair}>
          <Text style={styles.botaoText}>Sair</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

export default withNavigation(DrawerContent);
